import { render, staticRenderFns } from "./ProjectSettingsList.vue?vue&type=template&id=419c368a&scoped=true"
import script from "./ProjectSettingsList.vue?vue&type=script&lang=js"
export * from "./ProjectSettingsList.vue?vue&type=script&lang=js"
import style0 from "./ProjectSettingsList.vue?vue&type=style&index=0&id=419c368a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419c368a",
  null
  
)

export default component.exports